import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Loader2, FileText } from 'lucide-react';

export function OrderTermsCard({ 
  order, editingTerms, setEditingTerms, termsText, setTermsText, 
  onSaveTerms, savingTerms 
}) {
  return (
    <Card className="card-dashboard">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-heading uppercase">Terms & Conditions</CardTitle>
          {!editingTerms && (
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => setEditingTerms(true)}
              data-testid="edit-terms-btn"
            >
              <FileText className="mr-2 h-4 w-4" /> Edit
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {editingTerms ? (
          <div className="space-y-4">
            <Textarea
              value={termsText}
              onChange={(e) => setTermsText(e.target.value)}
              placeholder="Enter terms and conditions (each point on a new line)..."
              rows={8}
              className="font-mono text-sm"
              data-testid="terms-textarea"
            />
            <div className="flex justify-end gap-2">
              <Button 
                variant="outline" 
                onClick={() => {
                  setTermsText(order.terms_conditions || '');
                  setEditingTerms(false);
                }}
              >
                Cancel
              </Button>
              <Button 
                onClick={onSaveTerms} 
                disabled={savingTerms}
                className="btn-primary"
                data-testid="save-terms-btn"
              >
                {savingTerms ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
                Save Changes
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-sm">
            {order.terms_conditions ? (
              <div className="space-y-2">
                {order.terms_conditions.split('\n').map((line, i) => (
                  <p key={`line-${i}`} className="text-muted-foreground">{line}</p>
                ))}
              </div>
            ) : (
              <p className="text-muted-foreground italic">No terms and conditions specified. Click Edit to add.</p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
